import { render, staticRenderFns } from "./chessOrderList.vue?vue&type=template&id=48b8f612&scoped=true"
import script from "./chessOrderList.vue?vue&type=script&lang=ts"
export * from "./chessOrderList.vue?vue&type=script&lang=ts"
import style0 from "./chessOrderList.vue?vue&type=style&index=0&id=48b8f612&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b8f612",
  null
  
)

export default component.exports